<template>
   <Layout>
      <section class="section" v-show="isEnabled">
         <div class="container">
            <center>
               <h3 class="survey-name">Conference Survey</h3>
            </center>
            <center v-if="data.questions.length < 1 && (!data.companies || data.companies.length < 1)">There are no data</center>
            <div v-else class="questions-label"></div>
            <div class="row" v-for="(question, index) in data.questions" :key="question.id">
               <div class="container">
                  <h4 class="question">
                     <span>{{ index+1 }})</span>
                     {{ question.question }}
                     <span class="required-question" > {{ question.is_optional ? '' : '*' }} </span>
                  </h4>
                  <div v-if="question.type == 1">
                     <ul>
                        <li
                           class="answer"
                           v-for="(choice, choiceIndex) in question.choices"
                           :key="question.id.toString() + choiceIndex"
                        >
                        <input v-if="question.type === 1" type="radio" v-model="question.answer" :value="choice"  >
                        <input v-else type="checkbox" v-model="question.answer" :value="choice" >
                           {{ choice }}
                        </li>
                     </ul>
                  </div>
                  <div v-else-if="question.type == 2">
                     <textarea v-model="question.answer"></textarea>
                  </div>

                  <hr />
               </div>
            </div>

            <table class="table table-striped" v-if="data.companies && data.companies.length">
               <thead>
                  <tr>
                     <th>Company</th>
                     <th>Level Of Disclosure</th>
                     <th>Presentation Skills</th>
                     <th>Ability To Address Inquiries</th>
                     <th>Comments</th>
                  </tr>
               </thead>
               <tbody>
                  <tr v-for="company in data.companies" :key="company.id">
                     <td>{{company.name}}</td>
                     <td>
                        <select v-model="company.questions[0].answer">
                           <option
                              v-for="(choice, index) in company.questions[0].choices"
                              :key="index.toString() + company.id"
                           >{{choice}}</option>
                        </select>
                     </td>
                     <td>
                        <select v-model="company.questions[1].answer">
                           <option
                              v-for="(choice, index) in company.questions[1].choices"
                              :key="index.toString() + company.id"
                           >{{choice}}</option>
                        </select>
                     </td>
                     <td>
                        <select v-model="company.questions[2].answer">
                           <option
                              v-for="(choice, index) in company.questions[2].choices"
                              :key="index.toString() + company.id"
                              :value="choice"
                           >{{choice}}</option>
                        </select>
                     </td>
                     <td>
                        <textarea cols="20" rows="2" v-model="company.questions[3].answer"></textarea>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </section>
      <section class="section section-sm" v-show="isEnabled">
         <div class="container">
            <div class>
               <div class="row">
                  <div class="col-md-12">
                     <input
                        @click="postSurvey"
                        value="Submit"
                        type="submit"
                        class="btn btn-outline-clr btn-sm"
                     />
                  </div>
               </div>
            </div>
         </div>
      </section>
      <section class="section" v-show="error_message != ''">
         <div class="container">
            <div class="alert alert-danger">{{ error_message }}</div>
         </div>
      </section>
      <section class="section" v-show="success_message != ''">
         <div class="container">
            <div class="alert alert-success">{{ success_message }}</div>
         </div>
      </section>
   </Layout>
</template>

<script>
import Vue from "vue";
import collect from "collect.js";
var _ = require("lodash");
import Api from "@/Api";
import Layout from "@/components/layouts/Layout.vue";

export default {
   name: "MySurvey",
   components: { Layout },
   data() {
      return {
         error_message: "",
         success_message: "",
         isEnabled: false,
         data: {
            questions: [],
            companies: null
         }
      };
   },
   methods: {
      getPageData() {
         Api()
            .get("auth/my-survey")
            .then(({ data }) => {
               this.data.questions = this.mappingQuestions(data.survey).sort((a,b) => a.order - b.order )  ;
               this.data.companies = data.companies;
               this.isEnabled = true;
            })
            .catch(error => {
               if (error) {
                  if (error.response.status == 422) {
                     let err = error.response.data;
                     this.error_message = err.errors[0].message;
                  } else if (error.response.status == 401) {
                     this.$store.dispatch("logout");
                     this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute.fullPath } });
                  }
               }
            });
      },
      postSurvey() {
         if (this.checkIfAllAnswered()) {
            return alert("Please answer all the questions");
         }
         let answers = this.collectAnswers();
         let companies_answers = this.collectCompaniesAnswers();
         // console.log("answer len " , answers ) ;
         Api()
            .post("auth/my-survey", {
               answers: answers,
               companies_answers: companies_answers
            })
            .then(response => {
               let data = response.data;
               this.success_message = data.message;
               this.isEnabled = false;
            })
            .catch(error => {
               if (error) {
                  if (error.response.status == 422) {
                     let err = error.response.data;
                     this.error_message = err.errors[0].message;
                  } else if (error.response.status == 401) {
                     this.$store.dispatch("logout");
                     this.$router.push("login");
                  }
               }
            });
      },
      collectAnswers() {
         return this.data.questions.map(question => {
            return {
               question_id: question.id,
               answer: question.answer
            };
         });
      },
      collectCompaniesAnswers() {
         let companies_answers = [];
         if(!this.data.companies) return [] ;
         for (let company in this.data.companies) {
            for (let question in this.data.companies[company].questions) {
               companies_answers.push({
                  company_id: company.id,
                  question_id: this.data.companies[company].questions[question].id,
                  answer: this.data.companies[company].questions[question].answer
               });
            }
         }
         return companies_answers;
      },
      mappingQuestions(questions) {
         questions.map(question => {
            if (question.type == 1) {
               question.answer = null;
            } else if (question.type == 2) {
               question.answer = [];
            }
            return question;
         });
         return questions;
      },
      checkIfAllAnswered() {
         let questions = collect(this.data.questions);

         let companies_questions = collect([]) ;

         if(this.data.companies)
         {
            companies_questions = collect(collect(this.data.companies).flatMap(company => company.questions));
         }

         return (
            questions.filter(question => _.isEmpty(question.answer) && !question.is_optional ).toArray()
               .length > 0 ||
            companies_questions
               .filter((question, i) =>  _.isEmpty(question.answer) && !question.is_optional )
               .toArray().length > 0
         );
      }
   },
   created() {
      this.getPageData();
   }
};
</script>

<style scoped>
.questions-label {
   font-size: 1.5rem;
   font-weight: bold;
   margin-bottom: 10px;
   color: #004c2c;
}
.survey-name {
   display: block;
   color: #004c2c;
   border-bottom: 1px solid #004c2c;
   padding-bottom: 10px;
}
.question {
   font-weight: bold !important;
   display: block;
   color: #004c2c !important;
   font-family: inherit;
   font-size: inherit;
   font-weight: inherit;
   line-height: inherit;
   color: inherit;
}
.answer {
   font-weight: normal !important;
   color: #004c2c !important;
   cursor: pointer;
}

.required-question {
   font-size: 1.3rem ;
   color : red ;
}

</style>
